import React from 'react';
import { Card } from '../components/ui/card';
import SEO from '../components/SEO';
import { Award, Users, Target, Heart, CheckCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Hakkımızda"
        description="15 yıllık tecrübe ile Bahçeşehir, Beylikdüzü, Esenyurt, Başakşehir ve Büyükçekmece'de halı ve koltuk yıkama hizmeti. 10.000+ mutlu müşteri."
        keywords="duru halı yıkama, bahçeşehir halı yıkama, profesyonel halı yıkama, güvenilir halı yıkama"
        canonical="https://www.bahcesehirduruhaliyikama.com/hakkimizda"
      />
      {/* Header */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Hakkımızda</h1>
          <p className="text-xl text-teal-50 max-w-3xl mx-auto">
            15 yıldır sektörde, binlerce mutlu müşteriyle hizmet veriyoruz.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Hikayemiz</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  <span className="font-bold text-teal-600">{companyInfo.name}</span>, 2008 yılında 
                  İstanbul'da kurulmuş olup, halı ve ev tekstili yıkama sektöründe 15 yılı aşkın 
                  tecrübesiyle güvenilir bir marka haline gelmiştir.
                </p>
                <p>
                  Modern tesislerimiz, son teknoloji ekipmanlarımız ve uzman kadromuz ile 
                  her türlü halı, koltuk ve ev tekstili için profesyonel temizlik hizmeti sunuyoruz.
                </p>
                <p>
                  Müşteri memnuniyeti odaklı hizmet anlayışımız, kaliteli işçilik ve uygun 
                  fiyatlarımız ile sektörde fark yaratıyoruz. Binlerce mutlu müşterimizin 
                  güvenini kazanmış bulunmaktayız.
                </p>
                <p>
                  Çevre dostu ürünler kullanarak hem halılarınızı koruyoruz hem de 
                  doğaya saygılı bir hizmet sunuyoruz.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <img
                  src="https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85"
                  alt="Halı Yıkama"
                  className="rounded-xl shadow-lg h-48 w-full object-cover"
                />
                <img
                  src="https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzb2ZhJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc1fDA&ixlib=rb-4.1.0&q=85"
                  alt="Koltuk Temizleme"
                  className="rounded-xl shadow-lg h-48 w-full object-cover mt-8"
                />
                <img
                  src="https://images.unsplash.com/photo-1742483359033-13315b247c74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85"
                  alt="Profesyonel Ekip"
                  className="rounded-xl shadow-lg h-48 w-full object-cover -mt-4"
                />
                <img
                  src="https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85"
                  alt="Modern Tesis"
                  className="rounded-xl shadow-lg h-48 w-full object-cover mt-4"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Değerlerimiz</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Başarımızın temelinde yatan prensiplerimiz
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { 
                icon: Award, 
                title: 'Kalite', 
                desc: 'Her işimizde en yüksek kalite standartlarını uygularız' 
              },
              { 
                icon: Users, 
                title: 'Müşteri Memnuniyeti', 
                desc: 'Müşterilerimizin memnuniyeti bizim önceliğimizdir' 
              },
              { 
                icon: Target, 
                title: 'Profesyonellik', 
                desc: 'Uzman ekibimiz ve modern ekipmanlarımızla hizmet veriyoruz' 
              },
              { 
                icon: Heart, 
                title: 'Güven', 
                desc: 'Şeffaf ve dürüst iş anlayışımız ile güven kazanıyoruz' 
              }
            ].map((value, index) => (
              <Card key={index} className="text-center p-8 border-2 hover:border-teal-500 transition-colors">
                <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <value.icon className="w-8 h-8 text-teal-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-gray-600">{value.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="py-20 bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            {[
              { number: '15+', label: 'Yıllık Tecrübe' },
              { number: '10,000+', label: 'Mutlu Müşteri' },
              { number: '25,000+', label: 'Yıkanan Halı' },
              { number: '%98', label: 'Memnuniyet Oranı' }
            ].map((stat, index) => (
              <div key={index}>
                <div className="text-5xl font-bold mb-2">{stat.number}</div>
                <div className="text-teal-100 text-lg">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 mb-8 text-center">Neden Bizi Tercih Etmelisiniz?</h2>
            <div className="space-y-4">
              {[
                'Modern ve hijyenik tesislerimizde halılarınız özenle yıkanır',
                'Çevre dostu ve organik temizlik ürünleri kullanılır',
                'Her türlü halı için özel bakım ve yıkama teknikleri uygulanır',
                'Ücretsiz alım ve teslim hizmeti sunulur',
                'Hızlı teslimat garantisi (2-3 gün)',
                'Deneyimli ve uzman kadromuz ile hizmet verilir',
                'Uygun fiyat ve esnek ödeme seçenekleri',
                'Leke çıkarma garantisi',
                'Renk koruma ve kumaş muhafazası',
                'Müşteri memnuniyeti odaklı hizmet'
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border-l-4 border-teal-600">
                  <CheckCircle className="w-6 h-6 text-teal-600 mt-0.5 flex-shrink-0" />
                  <p className="text-gray-700 text-lg">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
